import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface OnlyIntroModel extends BaseModel {
  variables?: { [key: string]: string } | OnlyIntroVariables;
}

export interface OnlyIntroVariables {
  OnlyIntro: string;
}

export class OnlyIntroInitVariables implements OnlyIntroVariables {
  OnlyIntro = '';
}

export class OnlyIntroInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new OnlyIntroInitVariables();
    this.variables = {...initVars};
    this.notifications = [new NotificationInitVariables()];
  }
}
